<script setup>
defineProps({ title: String, appraisals: Array, color: String });
</script>

<template>
  <v-row class="mb-4">
    <v-col cols="12">
      <h3 :class="`report-title intervention-status ${color}`">
        {{ title }}
      </h3>
      <v-table class="report-table">
        <thead>
          <tr>
            <th class="location-column" scope="col">
              <i18next :translation="$t('location')" />
            </th>
            <th class="intervention-column" scope="col">
              <i18next :translation="$t('intervention')" />
            </th>
            <th scope="col">
              <i18next :translation="$t('comments')" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="appraisal in appraisals"
            :key="appraisal.id"
            class="d-block d-md-table-row mb-2 mb-md-0"
          >
            <td
              :data-label="$t('location')"
              class="d-block d-md-table-cell text-right text-md-left py-2 pr-2 py-md-0 px-md-4"
            >
              {{ appraisal.locations[0].label }}
            </td>
            <td
              :data-label="$t('intervention')"
              class="d-block d-md-table-cell text-right text-md-left py-2 pr-2 py-md-0 px-md-4"
            >
              {{ appraisal.interventionLabel }}
            </td>
            <td
              :data-label="$t('comments')"
              class="d-block d-md-table-cell text-right text-md-left py-2 pr-2 py-md-0 px-md-4"
            >
              {{ appraisal.comments }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-col>
  </v-row>
</template>

<style scoped lang="scss">
.intervention-status::before {
  width: 14px;
  height: 14px;
}

.intervention-column,
.location-column {
  width: 25%;
}

.report-table {
  @media (max-width: 959px) {
    thead {
      display: none;
    }

    tr {
      border-bottom: 2px solid rgb(var(--v-theme-darkGray));

      td {
        border-bottom: 1px solid rgb(var(--v-theme-darkGray));
        height: 100% !important;
        min-height: 35px;

        &:before {
          content: attr(data-label);
          float: left;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
